

















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import ConfirmDialog from "@/components/dialogs/confirmDialog.vue";
import { deleteLabledTongue, getLableHistory } from "@/request/idr";
@Component({
  components: {
    ConfirmDialog
  }
})
export default class IdrSheZhuanjia extends Vue {
  @Prop()
  private current: any;
  @Prop()
  private tongueId: any;
  private cPart: any = "舌象信息输出";
  private ifShowDelete: boolean = false;
  private ifShowHistory: boolean = false;
  private historys: any[] = [];
  /**
   * @description 改变显示模块
   */
  private changePart(part) {
    this.cPart = part;
  }
  /**
   * @description 跳转舌图标注
   */
  private jumpBiaozhu() {
    this.$router.push({
      path: "/main/tongue/biaozhu-detail",
      query: {
        tongue_id: this.tongueId
      }
    });
  }
  /**
   * @description 打开确认删除弹窗
   */
  private openDelete() {
    this.ifShowDelete = true;
  }
  /**
   * @description 确定删除
   */
  private deleteTongue() {
    const params: any = {
      data: {
        tongue_id: this.tongueId
      }
    };
    deleteLabledTongue(this, params).then(() => {
      this.$message.success("删除成功");
      this.$emit("refresh");
    });
  }
  /**
   * @description 打开历史记录
   */
  private openHistory() {
    this.fetchHistory();
    this.ifShowHistory = true;
  }
  /**
   * @description 获得标注历史
   */
  private fetchHistory() {
    const params: any = {
      params: {
        tongue_id: this.tongueId
      }
    };
    getLableHistory(this, params).then((data: any) => {
      this.historys = data;
    });
  }
}
